import { validateStatus } from '../../../constants/DataSource.constants';
export var FilterOrSearch;
(function (FilterOrSearch) {
    FilterOrSearch["Filter"] = "Filter";
    FilterOrSearch["Search"] = "Search";
})(FilterOrSearch || (FilterOrSearch = {}));
export const DataSourceListConstants = {
    SET_USER_CONTEXT: 'dataSourceList/command/SET_USER_CONTEXT',
    SET_PARTIAL_USER_CONTEXT: 'dataSourceList/command/SET_PARTIAL_USER_CONTEXT',
};
export const getDefaultState = () => {
    return {
        userContext: {
            showStatus: [validateStatus.ValidateSuccess, validateStatus.ValidateFailed, validateStatus.Unknown],
            showAdditionalProps: null,
            filter: null,
            search: null,
            filterOrSearch: FilterOrSearch.Search,
        },
    };
};
const setPartialUserContext = (state, actionResult) => {
    return {
        ...state,
        userContext: {
            ...state.userContext,
            ...actionResult.payload,
        },
    };
};
export function setPartialUserContextFunc(userContext) {
    return {
        type: DataSourceListConstants.SET_PARTIAL_USER_CONTEXT,
        payload: userContext,
    };
}
export const setUserContext = (state, actionResult) => {
    return {
        ...state,
        userContext: actionResult.payload,
    };
};
export function setUserContextFunc(userContext) {
    return {
        type: DataSourceListConstants.SET_USER_CONTEXT,
        payload: userContext,
    };
}
export const DataSourceListReducer = (state = getDefaultState(), actionResult) => {
    switch (actionResult.type) {
        case DataSourceListConstants.SET_PARTIAL_USER_CONTEXT:
            return setPartialUserContext(state, actionResult);
        case DataSourceListConstants.SET_USER_CONTEXT:
            return setUserContext(state, actionResult);
        default:
            return state;
    }
};
export default DataSourceListReducer;

//# sourceMappingURL=DataSourceListFilter.ducks.js.map
